"use strict";
module.exports = require("./GroupingComponent");
